import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UserMockInterviewQuestionsSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function UserMockInterviewQuestionsSubTab() {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/user-mock-interview-questions`);
      setQuestions(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке вопросов: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этот вопрос?')) {
      try {
        await axios.delete(`${API_URL}/api/user-mock-interview-questions/${id}`);
        fetchQuestions();
      } catch (err) {
        setError('Ошибка при удалении вопроса: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="user-mock-interview-questions-sub-tab">
      <div className="tab-header">
        <h3>Вопросы пользовательских Mock-собеседований</h3>
        <button className="btn btn-secondary" onClick={fetchQuestions}>
          🔄 Обновить
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>ID собеседования</th>
              <th>Название собеседования</th>
              <th>Share ID</th>
              <th>Порядок</th>
              <th>Вопрос</th>
              <th>Правильный ответ</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {questions.length === 0 ? (
              <tr>
                <td colSpan="8" className="empty-state">
                  Нет вопросов пользовательских собеседований.
                </td>
              </tr>
            ) : (
              questions.map((question) => (
                <tr key={question.id}>
                  <td>{question.id}</td>
                  <td>{question.interview_id}</td>
                  <td className="interview-title-cell">{question.interview_title || '-'}</td>
                  <td className="share-id-cell">{question.interview_share_id || '-'}</td>
                  <td>{question.order_index !== null ? question.order_index : '-'}</td>
                  <td className="question-text">{question.question_text}</td>
                  <td className="answer-text">{question.correct_answer}</td>
                  <td>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(question.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserMockInterviewQuestionsSubTab;
